import { IconButton, useTheme } from "@mui/material";
import { X } from "lucide-react";
import type { MouseEvent } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	onRemove: () => void;
};

export const ReminderRemoveButton = ({ onRemove }: Props) => {
	const { t } = useResource();
	const theme = useTheme();

	const handleClick = (e: MouseEvent) => {
		e.stopPropagation();
		onRemove();
	};

	return (
		<IconButton
			aria-label={t(Resources.Reminders.Actions.remove)}
			onClick={handleClick}
			sx={{ bgcolor: theme.palette.grey[200] }}
		>
			<X size={theme.iconSize.sm} color={theme.palette.grey[600]} />
		</IconButton>
	);
};
